(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sr-bundles-product-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-sr-bundle-hero]');

    sections.forEach((section) => {
      if (section.dataset.srBundleHeroReady === 'true') return;
      section.dataset.srBundleHeroReady = 'true';

      const mediaItems = Array.from(section.querySelectorAll('[data-sr-bph-media]'));
      const thumbnails = Array.from(section.querySelectorAll('[data-sr-bph-media-target]'));

      thumbnails.forEach((button) => {
        button.addEventListener('click', () => {
          const target = button.dataset.srBphMediaTarget;

          mediaItems.forEach((item) => {
            item.hidden = item.dataset.srBphMedia !== target;
          });

          thumbnails.forEach((thumb) => {
            const active = thumb === button;
            thumb.classList.toggle('is-active', active);
            thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
        });
      });

      const quantityInput = section.querySelector('[data-sr-bph-quantity]');
      const minus = section.querySelector('[data-sr-bph-qty-minus]');
      const plus = section.querySelector('[data-sr-bph-qty-plus]');

      if (quantityInput && minus && plus) {
        minus.addEventListener('click', () => {
          const current = parseInt(quantityInput.value || '1', 10);
          quantityInput.value = Math.max(1, current - 1);
        });

        plus.addEventListener('click', () => {
          const current = parseInt(quantityInput.value || '1', 10);
          quantityInput.value = Math.max(1, current + 1);
        });
      }

      const sticky = section.querySelector('[data-sr-bph-sticky]');
      const mainBuy = section.querySelector('[data-sr-bph-main-buy]');
      const mainAdd = section.querySelector('[data-sr-bph-main-add]');
      const stickyAdd = section.querySelector('[data-sr-bph-sticky-add]');
      let stickyVisible = false;

      const updateRewardsWidgetPosition = (showSticky) => {
        const rewardsButton = document.getElementById('bon-loyalty-btn');
        if (!rewardsButton) return;

        const isMobile = window.innerWidth <= 649;

        if (isMobile && showSticky && sticky) {
          const stickyHeight = sticky.getBoundingClientRect().height;
          rewardsButton.style.setProperty('bottom', `${stickyHeight + 12}px`, 'important');
        } else {
          rewardsButton.style.setProperty('bottom', '20px', 'important');
        }
      };

      const setStickyVisibility = (show) => {
        if (!sticky) return;

        stickyVisible = show;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        updateRewardsWidgetPosition(show);
      };

      const updateStickyVisibility = () => {
        if (!sticky || !mainBuy || window.innerWidth > 649) {
          setStickyVisibility(false);
          return;
        }

        const rect = mainBuy.getBoundingClientRect();
        setStickyVisibility(rect.bottom < 0);
      };

      if (sticky && mainBuy) {
        window.addEventListener('scroll', updateStickyVisibility, { passive: true });
        window.addEventListener('resize', updateStickyVisibility);
        updateStickyVisibility();
      }

      if (stickyAdd && mainAdd) {
        stickyAdd.addEventListener('click', () => {
          if (mainAdd.disabled) {
            section.scrollIntoView({
              behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
              block: 'start'
            });
            return;
          }

          mainAdd.click();
        });
      }

      section.querySelectorAll('a[href^="#"]').forEach((link) => {
        link.addEventListener('click', (event) => {
          const targetId = link.getAttribute('href');
          if (!targetId || targetId === '#') return;

          const target = document.querySelector(targetId);
          if (!target) return;

          event.preventDefault();
          target.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'start'
          });
        });
      });

      if (document.body && typeof MutationObserver !== 'undefined') {
        const observer = new MutationObserver(() => {
          if (document.getElementById('bon-loyalty-btn')) {
            updateRewardsWidgetPosition(stickyVisible);
          }
        });

        observer.observe(document.body, { childList: true, subtree: true });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
